import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { Store } from 'effector';
import { format } from 'patronum';
import { RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import { createPaginatedSchema, Promocode, promocodeSchema } from '../types';

export type OriginalPromocodeRegistryParams = {
	sortField?: string | null;
	sortDirection?: string;
	page?: number;
	limit?: number;
	statuses?: string[];
};

export type PromocodeRegistryFilters = {
	statuses: string[];
};

export type PromocodeRegistryParams = RegistryParams<PromocodeRegistryFilters>;

export type PromocodeRegistryQuery = RegistryQuery<
	Promocode,
	PromocodeRegistryFilters,
	JsonApiRequestError
>;

export const createPromocodeRegistryQuery = (
	$voucherId: Store<number | null>,
): PromocodeRegistryQuery =>
	createAuthQuery({
		params: declareParams<PromocodeRegistryParams>(),
		request: {
			method: 'GET',
			url: format`/voucher/item/list/${$voucherId}`,
			query: (params): OriginalPromocodeRegistryParams => ({
				page: params.page,
				limit: params.limit,
				sortField: params.sortField ?? undefined,
				sortDirection: params.sortDirection,
				statuses: params.filters.statuses.length === 0 ? undefined : params.filters.statuses,
			}),
		},
		response: {
			contract: zodContract(createPaginatedSchema(promocodeSchema)),
		},
	});
